import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import StandardizedChip from '../../common/StandardizedChip';

/**
 * PolicyEntitiesTab Component
 *
 * Displays supported entities for the policy.
 *
 * @param {Object} props
 * @param {Array} props.entities - Array of entity names
 */
function PolicyEntitiesTab({ entities }) {
  if (!entities || entities.length === 0) {
    return (
      <Alert severity="info">
        No specific entities defined for this policy
      </Alert>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Supported Entities
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        This policy can identify and process the following entity types:
      </Typography>
      <Box display="flex" flexWrap="wrap" gap={1}>
        {entities.map((entity, index) => (
          <StandardizedChip
            key={index}
            label={entity}
            color="primary"
            variant="outlined"
          />
        ))}
      </Box>
    </Box>
  );
}

export default PolicyEntitiesTab;
